import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M15.163 6.952h1.687l-3.685 4.212 4.335 5.73h-3.394l-2.659-3.475-3.042 3.476H6.717l3.942-4.505L6.5 6.952h3.48l2.404 3.177zm-.592 8.933h.935L9.473 7.91H8.47z"
    }, null, -1)
  ])))
}
export default { render: render }